import React from 'react';
import { motion } from 'framer-motion';
interface SectionEyebrowProps {
  text: string;
  className?: string;
}
export function SectionEyebrow({
  text,
  className = ''
}: SectionEyebrowProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className={`font-mono text-sm text-iris-green tracking-widest uppercase flex items-center gap-2 ${className}`} data-id="element-309">
      <span className="opacity-70" data-id="element-310">{'//'}</span>
      {text}
    </motion.div>;
}